import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Command } from './command';
import { CommandEvents } from './command-events';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';

export class SupprimerObjetMaquetteCommand implements Command<void> {
    constructor(
        private codeStructure: string,
        private id: string,
        private version: string,
        private events: CommandEvents,
        private objetMaquetteService: ObjetMaquetteService,
        private ignoreConflict: boolean
    ) {}

    do(): Observable<void> {
        return this.objetMaquetteService.supprimerObjetMaquette(this.id, this.version, this.ignoreConflict).pipe(
            tap(() => {
                this.events.objetMaquetteSupprime$.next(this.id);
            })
        );
    }

    destroy() {}
}
